// Open Quick Add modal for sibling products when clicking color swatches
(function () {
  function onClick(e) {
    const link = e.target.closest('.card__swatches .swatch-link[data-quick-add-url]');
    if (!link) return;
    // Allow middle-click or modified clicks to open in new tab
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;

    e.preventDefault();
    const card = link.closest('.product-card-wrapper, .card-wrapper');
    if (!card) {
      window.location.href = link.getAttribute('href');
      return;
    }
    const opener = card.querySelector('modal-opener[data-modal] button');
    if (!opener) {
      window.location.href = link.getAttribute('href');
      return;
    }
    // Set product URL for the modal fetch, then trigger open
    opener.setAttribute('data-product-url', link.dataset.quickAddUrl);
    opener.click();
  }

  document.addEventListener('click', onClick);
})();

